import React, { FC } from 'react';
import { FaRegCircle, FaCheckCircle, FaCircleNotch } from 'react-icons/fa';

export enum StepStatus {
    Completed,
    Current,
    Invalid
}

interface Props {
    stepState: {
        status: StepStatus
    }
}

const getIcon = (status: StepStatus) => {
    switch(status) {
        case StepStatus.Completed:
            return <FaCheckCircle className="valid" />;
        case StepStatus.Current:
            return <FaCircleNotch className="valid" />;
        default:
            return <FaRegCircle className="invalid" />;
    }
};

const CircleStatus: FC<Props> = ({ stepState }) => {
    return (
        <React.Fragment>
            {getIcon(stepState.status)}
        </React.Fragment>
    ); 
};

export default CircleStatus;